import { IconLock } from "@tabler/icons-react";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty";

export const Route = createFileRoute("/_authed/coming-soon/$feature")({
  beforeLoad: ({ params }) => {
    if (params.feature === "all-products") throw redirect({ to: "/all-products" });
  },
  component: ComingSoonPage,
});

export function ComingSoonPage(): React.ReactElement {
  const { t } = useTranslation("layout");

  return (
    <main className="flex min-h-full min-w-[1024px] px-6 pb-6 pt-5">
      <Empty className="rounded-[14px] border border-line bg-surface shadow-[0_1px_3px_rgb(10_10_10_/_0.03)]">
        <EmptyHeader>
          <EmptyMedia variant="icon" className="mb-3 text-muted-foreground">
            <IconLock className="size-5" aria-hidden />
          </EmptyMedia>
          <EmptyTitle>{t("comingSoon.title")}</EmptyTitle>
          <EmptyDescription>{t("comingSoon.description")}</EmptyDescription>
        </EmptyHeader>
      </Empty>
    </main>
  );
}
